<template>
<Row :gutter="8">
  <Col :span="24">
    <div id="siteSdvStat"></div>
  </Col>
</Row>
</template>

<script>
import echarts from 'echarts'
import { ListSiteSdvData } from '@/api/stat'

export default {
  name: 'sdv-stat',
  data: function () {
    return {
      height: '160px'
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListSiteSdvData(id).then(async res => {
        this.drawProgress(res)
      })
    },
    drawProgress: function (res) {
      var opts = {
        width: 'auto',
        height: (res.sites.length * 60 + 60) + 'px'
      }
      this.charts = echarts.init(document.getElementById('siteSdvStat'), 'light', opts)
      var options = {
        title: {
          text: '各中心受试者表单SDV情况',
          x: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: 10,
          data: res.statuses
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        yAxis: {
          type: 'category',
          data: res.sites
        },
        xAxis: {
          type: 'value'
        },
        series: res.series
      }
      this.charts.setOption(options)
    }
  }
}
</script>
